<script setup lang="ts">
/**
 * The Loading Overlay
 * --------------------------------
 * Glboal loading overlay that shows a spinner and blocks user interaction when loading.
 */

const {
    mode = 'light',

} = defineProps<{
    mode?: 'dark' | 'light';

}>();

const { isLoading } = useLoading();

const transitionName = computed(() => {
    const runtimeConfig = useRuntimeConfig();
    return runtimeConfig.public.disableLoadingOverlayTransition ? '' : 'loading-overlay';
});

const backdropClasses = computed(() => ({
    'bg-brand-b/90': mode === 'dark',
    'bg-background-1/90': mode === 'light',
}));
</script>

<template>
    <Transition :name="transitionName">
        <div
            v-if="isLoading"
            data-t-loading-overlay
            class="
                fixed
                inset-0
                z-50
            "
            :class="backdropClasses"
        >
            <LoadingSpinner
                data-spinner
                class="absolute top-1/2 left-1/2 size-14! -translate-1/2"
                :mode="mode === 'dark' ? 'light' : 'dark'"
            />
        </div>
    </Transition>
</template>

<style scoped>
    .loading-overlay-enter-active,
    .loading-overlay-leave-active {
        transition: opacity 0.3s 0.2s;
    }
    .loading-overlay-enter-from {
        opacity: 0;
    }
    .loading-overlay-leave-to {
        opacity: 0;
    }

    .loading-overlay-enter-active [data-spinner],
    .loading-overlay-leave-active [data-spinner] {
        transition: opacity 0.3s 0.5s;
    }
    .loading-overlay-enter-from [data-spinner] {
        opacity: 0;
    }
    .loading-overlay-leave-to [data-spinner] {
        opacity: 0;
    }
</style>
